import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";

const SearchHeader = ({
    showSearch,
    searchTerm,
    setSearchTerm,
    transactionType,
    setTransactionType,
    isLoading
}) => {
    return (
        <div className="flex items-center justify-between mb-6">
            <h1 className="text-2xl font-bold">Credit Transactions</h1>
            {(showSearch && !isLoading) && (
                <div className="hidden lg:flex items-center gap-4">
                    <div className="relative">
                        <Search className="absolute left-2 top-2.5 h-4 w-4 text-gray-500" />
                        <Input
                            placeholder="Search transactions..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="pl-8 w-64 bg-white"
                        />
                    </div>
                    <Select
                        value={transactionType}
                        onValueChange={setTransactionType}
                    >
                        <SelectTrigger className="w-52">
                            <SelectValue placeholder="Transaction Type" />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectItem value="all">All Types</SelectItem>
                            <SelectItem value="analysis">Website Analysis</SelectItem>
                            <SelectItem value="analysis_refund">Analysis Refund</SelectItem>
                            <SelectItem value="credit_purchase">Credit Purchase</SelectItem>
                            <SelectItem value="custom_type_creation">Custom Type Creation</SelectItem>
                        </SelectContent>
                    </Select>
                </div>
            )}
        </div>
    );
};

export default SearchHeader;